<template>
  <FontAwesomeIcon
    v-if="type === 'facebook'"
    :icon="faFacebook"
    :class="[
      variant === 'default' ? 'text-[#1877f2]' : 'text-default-700',
    ]"
    aria-hidden="true"
    v-bind="$attrs"
  />
  <span
    v-if="type !== 'facebook'"
    :class="[
      'inline-flex items-center justify-center rounded-full',
      variant === 'default' ? typeColors.get(type) : 'bg-default-700',
    ]"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <template v-if="type === 'tiktok'">
      <img
        v-if="variant === 'default'"
        :src="TikTok"
        class="size-2/3"
        alt=""
      >
      <FontAwesomeIcon
        v-else
        :icon="icons.get(type) as IconDefinition"
        class="size-2/3 text-white"
      />
    </template>
    <FontAwesomeIcon
      v-else
      :icon="icons.get(type) as IconDefinition"
      class="size-2/3 text-white"
    />
  </span>
</template>

<script lang="ts" setup>
import {
  faFacebook,
  faInstagram,
  faLinkedin, faTiktok,
  faXTwitter,
  faYoutube,
} from '@awesome.me/kit-644ec404bf/icons/classic/brands';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TikTok from '../../../images/logos/tiktok.svg';
import ConnectionType = App.Enums.ConnectionType;

type ConnectionIconType = ConnectionType | 'tiktok' | 'x' | 'youtube';
type ConnectionVariant = 'default' | 'monochrome';

withDefaults(defineProps<{
  type: ConnectionIconType;
  variant?: ConnectionVariant;
}>(), {
  variant: 'default',
});

const typeColors = new Map<ConnectionIconType, string>([
  ['instagram', 'bg-[linear-gradient(45deg,#faadaf_0%,#dd2a7e_30%,#9537b0_60%,#515bd4_100%)]'],
  ['linkedin', 'bg-[#0a66c2]'],
  ['tiktok', 'bg-black'],
  ['x', 'bg-black'],
  ['youtube', 'bg-[#ff0000]'],
]);

const icons = new Map<ConnectionIconType, IconDefinition>([
  ['instagram', faInstagram],
  ['linkedin', faLinkedin],
  ['x', faXTwitter],
  ['youtube', faYoutube],
  ['tiktok', faTiktok],
]);
</script>
